module.exports = __webpack_public_path__ + "static/media/home-process-4.6f8ba94b.svg";